import { StateParams, StateService } from "@uirouter/angularjs";
import { IOnInit, IPromise } from "angular";
import {
  IFieldArray,
  IFieldRuntimeObject,
  ITemplateScope,
} from "AngularFormly";
import { FormViewController } from "../../../../../app/records/forms/formView/controller";
import { set } from "lodash";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../app/records/server/serverUtility";

import {
  FormViewService,
  vsName as FormViewServiceName,
} from "../../../../../app/records/forms/formView/service";
import fieldHelpers from "../../../../../app/ui-formly/fieldHelpers";
import { IRowCommandEventArgs } from "../../../../records/grids/controller";
import { Record } from "../../../../records/server/crud";
import { $confirm } from "../../../../../@custom_types/confirm";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../../app/records/forms/formly/fieldConfigurationHelpers";
import { Contract } from "../../../shared/models/contract";
import { ContractConfiguration } from "../../../shared/models/contractConfiguration";

import { RecordDataSource } from "../../../../records/grids";
import { ColDef } from "../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../records/server/query";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../records/views/recordGridView";
const gridId = Symbol("main.contract.relationship");
export class ContractInstanceDetailController implements IOnInit {
  static $inject = [
    FormViewServiceName,
    "$state",
    FieldConfigurationHelperServiceName,
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    RecordGridViewServiceName,
    "$confirm",
  ];
  model!: any;
  formFields!: IFieldArray;
  contractInstance!: any;
  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};
  
  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    private readonly fieldConfigurationHelperService: FieldConfigurationHelperService,
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    private readonly recordGridViewService: RecordGridViewService,
    private readonly $confirm: $confirm
  ) {
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/contract/contractRelationship"
    );
    this.gridSettings = gridSettingsService.getGridSettings(gridId);
    this.columns = [
      columnDefinitionService.getCommandColDef({
        headerName: "delete",
        name: "delete",
        iconClass: "fa fa-trash text-primary",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "Id",
        header: "Id",
      }),
      columnDefinitionService.getStringColDef({
        field: "RelationshipType",
        header: "Type",
      }),
      columnDefinitionService.getNumberColDef({
        field: "LeftContractInstanceId",
        header: "Contract Master Agreement",
      }),
      columnDefinitionService.getNumberColDef({
        field: "RightContractInstanceId",
        header: "Contract",
      }),
      
    ];
  }

  private nullWhenNotValue(watch: string, value: string) {
    return {
      expression: watch,
      listener: (
        field: IFieldRuntimeObject,
        newValue: any,
        _: any,
        scope: ITemplateScope
      ) => {
        if (newValue !== value) {
          const path = field.key ?? "";
          set(scope.model ?? {}, path, undefined);
        }
      },
    };
  }

  private initializeFormFields() {
    const that = this;
    const detailsField = fieldHelpers.simpleStringField({
      key: "Details",
      name: "Details",
      label: "Details ",
      hideExpression: "model.OwnedLeased !== 'Owned'",
      expressionProperties: {
        "templateOptions.required": "model.OwnedLeased === 'Owned'",
      },
      className: "col-xs-6",
      watcher: [that.nullWhenNotValue("model.OwnedLeased", "Owned")],
    });

    this.formFields = [
      
      ...fieldHelpers.columnLayout(
        [
          

          that.fieldConfigurationHelperService.selectAsyncField({
            key: "LeftContractInstanceId",
            name: "LeftContractInstanceId",
            label: "Contract Master Agreement",
            required: true,
            queryUrl: "/api/contract/contractMasterAgreement",
            getDefaultItem: function (model: any) {
              return {
                Id: model.ContractMasterAgreement?.ContractInstanceId,
                Name: model.ContractMasterAgreement?.Name,
              };
            },
          }),
          that.fieldConfigurationHelperService.selectAsyncField({
            key: "RightContractInstanceId",
            name: "RightContractInstanceId",
            label: "Contract",
            required: true,
            queryUrl: "/api/contract/contract",
            getDefaultItem: function (model: any) {
              return {
                Id: model.Contract?.ContractInstanceId,
                Name: model.Contract?.Name,
              };
            },
          }),
          
        ],
        2
      ),
      
      
    ];

    detailsField.className = "col-xs-6";
  }

  $onInit(): void {
    this.model =  {};

    this.initializeFormFields();
    //this.model = this.contractInstance ? this.contractInstance : {};
    this.model.RelationshipType = "ParentChild";
  }

  submit(formViewController: FormViewController): IPromise<void> {
    
    const serverRequest = this.formViewService.submitForm<Contract<ContractConfiguration>>({
          url: `/api/contract/contractRelationship`,
          formObject: this.model,
          formViewController,
          method: "POST",
        });
  
    return serverRequest.then((contract) => {
      this.$state.go("main.contract.instances");
    });
  }
  

  cancel(): IPromise<void> {
    const contractId = this.model.Id;
    return !!contractId
      ? this.$state
          .go("main.contract.info.Machine", { contractId }, { reload: true })
          .then(() => {})
      : this.$state.go("^.grid", undefined, { reload: true }).then(() => {});
  }

  onItemCommand(args: IRowCommandEventArgs<Record>) {
    switch (args.commandName) {
      case "delete":
        const actionId = args.data.Id;
        this.$confirm({
          text: "Are you sure you want to delete this action?",
        }).then(() =>
          this.serverUtility
            .sendApiRequest({
              method: "DELETE",
              url: `api/contract/contractRelationship/${actionId}`,
            })
            .then(() => {
              args.gridApi.onNewDatasource();
            })
        );
        break;
    }
  }
}
